import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';

export const useAvatar = (): string | undefined => UserStore.user?.avatar ?? (ThemeStore.theme.metadata as Record<string, string> | undefined)?.['user:defaultAvatar'];
